import { render, staticRenderFns } from "./BottomNavigationMenuIcon.vue?vue&type=template&id=3a872340"
import script from "./BottomNavigationMenuIcon.vue?vue&type=script&lang=js"
export * from "./BottomNavigationMenuIcon.vue?vue&type=script&lang=js"
import style0 from "./BottomNavigationMenuIcon.vue?vue&type=style&index=0&id=3a872340&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports